// src/context/LanguageContext.js
import { createContext, useContext, useState, useCallback } from 'react';
import { translations } from '../data/translations';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      const saved = localStorage.getItem('waceas_language');
      if (saved && ['en', 'fr', 'es'].includes(saved)) return saved;
      const browser = navigator.language.split('-')[0];
      return ['en', 'fr', 'es'].includes(browser) ? browser : 'en';
    } catch {
      return 'en';
    }
  });

  const changeLang = useCallback((newLang) => {
    setLang(newLang);
    try { localStorage.setItem('waceas_language', newLang); } catch {}
  }, []);

  // t('nav.home') → traverses nested object
  const t = useCallback((key) => {
    const keys = key.split('.');
    let val = translations[lang];
    for (const k of keys) {
      val = val?.[k];
    }
    if (val === undefined || val === null) {
      let fallback = translations['en'];
      for (const k of keys) fallback = fallback?.[k];
      return fallback ?? key;
    }
    return val;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, changeLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
